function Faq() {
  return (
    <div>
      <h1> FAQ Page </h1>
    </div>
  );
}

export default Faq;